import type { ComposantEcran } from '../../app/ecrans.js';
import { Appel } from './EcranAppel.js';
import { FileDuJour } from './EcranFileDuJour.js';
import { FicheRapideEcran } from './EcranFicheRapide.js';

/** Écrans du lot L52 : D02 (file du jour), M02 (appel en cours), M03 (fiche rapide). */
export const ecrans: Readonly<Record<string, ComposantEcran>> = { D02: FileDuJour, M02: Appel, M03: FicheRapideEcran };
